const education = (data) => {
  return {
    educations:data?.educations ,
  }
}

export default education
